import React from 'react';

/** Tile text wraps on spaces and after a slash. It does not break a word. */
export const GRID_LABEL_STYLE = {
  overflowWrap: 'normal',
  wordBreak: 'normal',
  hyphens: 'none',
  WebkitHyphens: 'none',
  minWidth: 0,
  maxWidth: '100%',
};

export default function GridLabel({ children, style }) {
  const text = String(children == null ? '' : children);
  const parts = text.split('/');
  return (
    <span className="grid-label" style={{ ...GRID_LABEL_STYLE, ...style }}>
      {parts.map((part, index) => (
        <React.Fragment key={`${part}-${index}`}>
          {index > 0 ? '/' : ''}
          {index > 0 ? <wbr /> : null}
          {part}
        </React.Fragment>
      ))}
    </span>
  );
}
